import { Moment } from 'moment'

import { IAppointmentFormSubmission } from '../../types'
import { IAPICreateAppointment } from '../../types/api'

import { appointmentSpecialDataTransformer } from './appointmentSpecialDataTransformer'

export const createAppointmentTransformer = (
  data: IAppointmentFormSubmission,
): IAPICreateAppointment => {
  const repeatStopsAtValue: null | Moment =
    typeof data.repeatStopsAt === 'undefined' ? null : data.repeatStopsAt
  const specialDataTransformer = appointmentSpecialDataTransformer(
    data.startHour,
    data.startsAt,
    data.repeatWeekInterval,
    data.repeatStopsAfter,
    repeatStopsAtValue,
  )
  return {
    customer_uuid: data.customerUuid,
    starts_at: specialDataTransformer.startsAt,
    appointment_activities: data.appointmentActivities.map(activity => ({
      activity_uuid: activity.activityUuid,
      is_locked: activity.isLocked,
      person_uuids: activity.personUuids,
    })),
    is_repeat: data.isRepeat,
    repeat_week_interval: data.repeatWeekInterval,
    repeat_stops_at: specialDataTransformer.repeatStopsAt,
    notes: data.notes,
  }
}
